import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */


const IconClose = () => {
    return (
        <svg
            className='icon-close'
            fill='none'
            height='44'
            width='44'
            xmlns='http://www.w3.org/2000/svg'>
            <rect
                height='43'
                rx='21.5'
                stroke='#6C6C6C'
                width='43'
                x='.5'
                y='.5'/>
            <path
                clipRule='evenodd'
                d='M28.0044 28.707c.1953.1953.5119.1953.7071 0 .1953-.1952.1953-.5118 0-.7071l-5.9898-5.9896 6.0108-6.0105c.1952-.1953.1952-.5118 0-.7071-.1953-.1953-.5119-.1953-.7071 0l-6.015 6.0147-6.0148-6.0145c-.1953-.1953-.5119-.1953-.7071 0-.1953.1953-.1953.5118 0 .7071l5.9898 5.9896-6.0108 6.0105c-.1952.1953-.1952.5118 0 .7071.1953.1953.5119.1953.7071 0l6.015-6.0147 6.0148 6.0145Z'
                fill='#0E0E0E'
                fillRule='evenodd'/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconClose;
